export enum AppointmentPhoneStatus {
    Unselected,
    Selected,
    Partial,
    Searching,
    Invalid,
}
